<script>

    import { PickupStore } from '../stores'

    import MenuMain from '../$layouts/menu.main.svelte'
    import Modal from '../$components/modal.svelte'

    import Pickups from '../pickups/pickups.svelte'
    import PickupRead from '../pickups/pickup.svelte'
    import PickupCreate from '../pickups/pickup.create.svelte'

</script>

<MenuMain />

<div class="container">
    <Pickups />
</div>

<Modal id="PickupRead" title="Información recolección" >
    <PickupRead on:deleted={PickupStore.modalClose} />
</Modal>

<Modal id="PickupCreate" title="Agregar recolección" >
    <PickupCreate on:created={PickupStore.modalClose} on:canceled={PickupStore.modalClose} />
</Modal>